<template>
  <small-modal class="expanded-modal" @close="closeModal">
    <div class="main-wrapper">
      <div class="main-header">
        <h1 class="title">{{ $t("dashboard.topPages.title") }}</h1>
        <button class="export-button" @click="handleExportData">
          {{ $t("dashboard.topPages.export") }}<ExportIcon />
        </button>
      </div>
      <div class="header">
        <p class="subtitle">
          {{ $t("dashboard.topPages.subtitle") }}
        </p>
        <p class="subtitle">
          {{ $t("dashboard.topPages.numPages") }}
          <span>{{ pageMetrics.length }}</span>
        </p>
      </div>
      <div class="video-table-wrapper">
        <div class="video-table-header">
          <div
            class="header-item header-item-name"
            @click="handleHeaderClick('url')"
          >
            <p>{{ $t("dashboard.topPages.pageName") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'url' && selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'url' && selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div class="header-item" @click="handleHeaderClick('widgetDisplays')">
            <p>{{ $t("dashboard.topPages.impression") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'widgetDisplays' && selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'widgetDisplays' &&
                    selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div class="header-item" @click="handleHeaderClick('widgetClicks')">
            <p>{{ $t("dashboard.topPages.clicks") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'widgetClicks' && selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'widgetClicks' && selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div
            class="header-item"
            @click="handleHeaderClick('widgetClicksPercentage')"
          >
            <p>{{ $t("dashboard.topPages.clicksPercentage") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'widgetClicksPercentage' &&
                    selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'widgetClicksPercentage' &&
                    selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div class="header-item" @click="handleHeaderClick('videosWatched')">
            <p>{{ $t("dashboard.topPages.watched") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'videosWatched' && selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'videosWatched' && selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div v-if="false" class="header-item">
            <p>{{ $t("dashboard.topPages.topVideo") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'names' && selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'names' && selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div
            class="header-item"
            @click="handleHeaderClick('totalTimeWatched')"
          >
            <p>{{ $t("dashboard.topPages.totalTime") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'totalTimeWatched' &&
                    selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'totalTimeWatched' &&
                    selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div
            class="header-item"
            @click="handleHeaderClick('conversionCount')"
          >
            <p>{{ $t("dashboard.topPages.orders") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'conversionCount' &&
                    selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'conversionCount' &&
                    selectedArrow === -1,
                }"
              />
            </div>
          </div>
          <div
            class="header-item"
            @click="handleHeaderClick('conversionAmount')"
          >
            <p>{{ $t("dashboard.topPages.revenue") }}</p>
            <div class="sorting-arrows">
              <SortArrow
                :class="{
                  'selected-arrow':
                    selectedSorting === 'conversionAmount' &&
                    selectedArrow === 1,
                }"
              />
              <SortArrow
                class="reverse-arrow"
                :class="{
                  'selected-arrow':
                    selectedSorting === 'conversionAmount' &&
                    selectedArrow === -1,
                }"
              />
            </div>
          </div>
        </div>
        <div class="video-table-body">
          <div
            v-for="(page, index) in sortedPageMetrics"
            :key="index"
            class="video-table-row"
          >
            <div class="table-cell cell-video-name">
              {{ page.url }}
            </div>
            <div class="table-cell">
              {{ page.widgetDisplays }}
            </div>
            <div class="table-cell">
              {{ page.widgetClicks }}
            </div>
            <div class="table-cell">
              {{ formatPercentage(page.widgetClicksPercentage) }}%
            </div>
            <div class="table-cell">{{ page.videosPlayed }}</div>
            <div v-if="false" class="table-cell">image</div>
            <div class="table-cell">
              {{ formatMinutes(page.videosWatchedTime) }}
            </div>
            <div class="table-cell">{{ page.conversionCount }}</div>
            <div class="table-cell">
              {{ currency }} {{ Math.round(page.conversionAmount) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal.vue";
import SortArrow from "@/assets/svg/sort-arrow.svg?inline";
import ExportIcon from "@/assets/svg/export-icon.svg?inline";

export default {
  components: {
    SmallModal,
    SortArrow,
    ExportIcon,
  },
  props: {
    pageMetrics: {
      type: Array,
      default: () => [],
    },
    fromDate: {
      type: Date,
      required: true,
    },
    toDate: {
      type: Date,
      required: true,
    },
    selectedCampaigns: {
      type: Array,
      default: () => [],
    },
    deviceSelectorPicked: {
      type: String,
      default: "allDevices",
    },
    isAllCampaignsSelected: {
      type: Boolean,
      default: false,
    },
    isAgency: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: "$",
    },
  },
  data() {
    return {
      selectedSorting: "widgetClicksPercentage",
      selectedArrow: -1,
    };
  },
  computed: {
    sortedPageMetrics() {
      if (!this.pageMetrics) {
        return [];
      }
      const metricsArray = [...this.pageMetrics];
      const sortKey = this.selectedSorting;
      const arrow = this.selectedArrow;

      metricsArray.sort((a, b) => {
        let valA = a[sortKey];
        let valB = b[sortKey];

        if (valA === undefined || valA === null)
          valA = arrow === 1 ? Infinity : -Infinity;
        if (valB === undefined || valB === null)
          valB = arrow === 1 ? Infinity : -Infinity;

        if (sortKey === "url") {
          valA = String(valA).toLowerCase();
          valB = String(valB).toLowerCase();
        } else {
          valA = Number(valA);
          valB = Number(valB);
        }

        let comparison = 0;
        if (valA > valB) {
          comparison = 1;
        } else if (valA < valB) {
          comparison = -1;
        }
        return comparison * arrow;
      });
      return metricsArray;
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleHeaderClick(sortKey) {
      if (sortKey === null) return;

      if (this.selectedSorting === sortKey) {
        this.selectedArrow *= -1;
      } else {
        this.selectedSorting = sortKey;
        this.selectedArrow = 1;
      }
    },
    formatPercentage(value) {
      if (value === null || value === undefined || isNaN(value)) {
        return 0;
      }
      return Math.floor(Number(value));
    },
    async handleExportData() {
      const exportParams = {
        fromDate: new Date(this.fromDate).toISOString(),
        toDate: new Date(this.toDate).toISOString(),
        siteId: this.$store.state.account.user.siteId,
        exportType: "pages",
      };

      if (!this.isAllCampaignsSelected && this.selectedCampaigns.length > 0) {
        exportParams.campaignId = this.selectedCampaigns.map((c) => c._id);
      }

      if (this.deviceSelectorPicked !== "allDevices") {
        exportParams.device = this.deviceSelectorPicked;
      }

      try {
        const result = await this.$store.dispatch(
          "dashboard/exportDashboardDataAction",
          exportParams
        );
        return result;
      } catch (error) {
        console.error(error);
      }
    },
    formatMinutes(value) {
      if (value === null || value === undefined || isNaN(value)) return "0min";

      const totalMinutes = Math.floor(Number(value));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      if (hours > 0) {
        return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}min`;
      }
      return `${minutes}min`;
    },
    formatDurationToMMSS(totalSecondsWithDecimals) {
      if (
        totalSecondsWithDecimals === null ||
        totalSecondsWithDecimals === undefined ||
        isNaN(totalSecondsWithDecimals)
      ) {
        return "00:00";
      }
      const totalSeconds = Math.round(Number(totalSecondsWithDecimals));

      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      const paddedMinutes = String(minutes).padStart(2, "0");
      const paddedSeconds = String(seconds).padStart(2, "0");

      return `${paddedMinutes}:${paddedSeconds}`;
    },
  },
};
</script>

<style lang="scss">
.expanded-modal .small-modal.bigger {
  width: 90vw;
  max-width: 90vw;
  height: 90vh;
  max-height: 90vh;
  overflow: auto;
}
</style>

<style lang="scss" scoped>
.main-wrapper {
  padding: 32px;
}

.title {
  @include base-font;
  @include font-big;
  font-weight: 600;
}
.subtitle {
  @include base-font;
  @include font-normal;
  span {
    font-weight: 600;
  }
}

.videos-table-wrapper {
  border: 6px solid $dark-purple;
  border-radius: 8px;
}

.video-table-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  background-color: #ececec;
  padding: 12px 16px;
}

.header-item {
  padding: 0 4px;
  @include base-font;
  @include font-smaller;
  font-weight: 500;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  p {
    margin: 0;
  }
}
.header-item-name {
  text-align: left;
  justify-content: flex-start;
}

.sorting-arrows {
  display: flex;
  flex-direction: column;
  gap: 6px;
  transform: scale(60%);
}

.selected-arrow {
  path {
    fill: $light-purple;
  }
}

.reverse-arrow {
  transform: translateX(-0.9px);
  path {
    transform: rotate(180deg);
    transform-origin: 50% 50%;
  }
}

.video-table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  @include base-font;
  @include font-smaller;
  padding: 12px 16px;
  border-bottom: 1px solid $light-grey;

  &:hover {
    background-color: #f6f6f6;
  }
}

.table-cell {
  padding: 0 4px;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &:last-child {
    border-right: none;
  }
}

.cell-video-name {
  text-align: left;
  justify-content: flex-start;
}

.video-thumbnail {
  width: 40px;
}

.flex-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 71px;
}

.name-date {
  display: flex;
  flex-direction: column;
  gap: 4px;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  span {
    color: #7f7f7f;
  }
}
.main-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.export-button {
  @include base-font;
  @include font-smaller;
  font-weight: 500;
  height: 30px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border: 1px solid $light-grey;
  color: $light-grey;
  background: white;
  border-radius: 3px;

  &:hover {
    border: 1px solid $dark-purple;
    background: $light-pink;
  }
}
</style>
